import React from 'react'

import Base from '../_Base'

const Missing = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M2,20 L22,20 L22,4 L2,4 L2,20 Z M10,12.9 C10.5,12.099 10.9,11.299 11.2,10.5 C11.3,10.299 11.4,10.2 11.5,10.1 C11.9,10.4 12.3,10.7 12.7,11 C12.9,11.2 13.1,11.2 13.3,11.2 L14.3,11.2 L14.4,11.4 C14.6,11.799 14.8,12.299 15,12.799 L13.6,13.799 L12.5,12.799 C12.2,12.599 11.9,12.5 11.6,12.599 L10,12.9 Z M8.3,15.5 L11.6,14.5 L12.9,15.7 C13.1,15.9 13.3,16 13.6,16 C13.8,16 14,15.9 14.2,15.799 L16,14.5 C16.1,14.7 16.3,14.9 16.4,15.099 L16.7,15.5 C17.5,16.4 18.2,17.299 19,18 L6.1,18 C6.8,17.299 7.5,16.5 8.3,15.5 L8.3,15.5 Z M20,6 L20,16.2 C19.4,15.599 18.9,15 18.3,14.299 L18,13.799 C17.3,12.799 16.7,11.7 16.4,10.6 C16.3,10.299 16.2,10 16.1,9.799 C15.9,9.4 15.6,9.2 15.2,9.2 L13.8,9.2 C13.3,8.799 12.7,8.4 12.1,8.1 C11.9,8 11.8,8 11.7,8 C10.6,8.1 9.7,8.799 9.4,9.799 C8.1,12.599 6.2,15.2 4,17.4 L4,6 L20,6 Z"
      fillRule="evenodd"
    />
  </Base>
)

export default Missing
